<template>
    <div>
        <div class="page-title-container lighter-shadow">
            <i class="fas fa-sitemap icon"></i>
            <h1>Списък на екипи</h1>
        </div>
        <Grid class="grid"
              :config="config"
              :gridData="gridData"
              :loading="isLoading"
              @row-clicked="rowClicked">
        </Grid>

        <!--    Add team form    -->
        <form v-if="isUserAdmin" class="item-container team-add-form grid-shadow">
            <div class="tab-header-container">
                <h2 class="form-label">Добавяне на екип</h2>
            </div>

            <hr class="form-line">

            <InputText class="team-input"
                       @value-change="setAttribute"
                       :id="'name'"
                       :name="'name'"
                       :label="'Име'"
                       :placeholder="'Въведете име'"
                       :newValue="newTeam.name"
                       :showError="shouldShowError('name')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('name')" :text="errors['name']"></ErrorInput>

            <InputText class="team-input"
                       @value-change="setAttribute"
                       :id="'location'"
                       :name="'location'"
                       :label="'Локация'"
                       :newValue="newTeam.location"
                       :placeholder="'Въведете локация'">
            </InputText>

            <SelectDropDown v-if="countries"
                            class="team-input"
                            style="margin-bottom: 20px;"
                            :id="'countryDropdown'"
                            :name="'countryIso'"
                            :options="countries"
                            :placeholder="'Изберете ISO'"
                            :label="'Държава'"
                            :newSelected="{id: newTeam.countryIso}"
                            :selector="'iso'"
                            @selection-change="setCountry"
            />

            <Button class="save-team-button"
                    @click.native="addTeam"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>
        </form>
    </div>
</template>

<script>
    import Grid from "@/shared/components/grid/Grid";
    import teamsGridConfig from "@/components/team/team-list-grid.config";
    import redirectService from "@/services/redirect.service";
    import Button from "@/shared/components/button/Button";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import teamService from "@/services/team.service";
    import InputText from "@/shared/components/form/InputText";
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";
    import {mapGetters} from "vuex";

    export default {
        name: "TeamList",
        components: {SelectDropDown, InputText, Button, Grid, ErrorInput},
        created() {
            this.refreshTeams();
            sharedService.fetchCountries()
                .then(({data}) => {
                    data.forEach((country) => country.id = country.iso);
                    this.countries = data;
                });
        },
        data() {
            return {
                config: teamsGridConfig,
                gridData: [],
                isLoading: true,
                newTeam: {
                    name: null,
                    location: null
                },
                countries: null,
                errors: {}
            }
        },
        methods: {
            refreshTeams() {
                teamService.fetchTeams()
                    .then(response => {
                        if (response.data) {
                            const {data} = response;
                            data.forEach((team) => team.countryIso = team.country ? team.country.iso : '');
                            this.gridData = response.data;
                            this.isLoading = false;
                        }
                    });
            },
            setAttribute(value) {
                this.errors[value.name] = null;
                this.newTeam[value.name] = value.currentValue;
            },
            setCountry(value) {
                this.newTeam.countryIso = value.currentValue.iso;
            },
            addTeam() {
                teamService.addTeam(this.newTeam)
                    .then(() => {
                        this.refreshTeams();
                        this.newTeam = {name: '', location: '', countryIso: ''};
                    })
                    .catch((errors) => this.errors = errors.response.data.errors);
            },
            rowClicked(row) {
                redirectService.redirectToTeam(row.id);
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            }
        },
        computed: {
            ...mapGetters(['isUserAdmin'])
        }
    }
</script>

<style scoped>
    @import '../../css/shared/tabs.css';

    .grid {
        margin-top: 30px;
        display: inline-block;
        float: left;
    }

    .team-input {
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .save-team-button {
        width: 220px;
        height: 50px;
        font-size: 25px;
        margin: 45px;
    }

    .team-add-form {
        width: 600px;
        margin: 30px 0;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }
</style>
